var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin-fill (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 1.75C11.4482 1.75289 9.0017 2.76788 7.19729 4.57229C5.39288 6.37671 4.37789 8.82318 4.375 11.375C4.375 19.6109 13.125 25.8311 13.498 26.0914C13.6451 26.1945 13.8204 26.2498 14 26.2498C14.1796 26.2498 14.3549 26.1945 14.502 26.0914C14.875 25.8311 23.625 19.6109 23.625 11.375C23.6221 8.82318 22.6071 6.37671 20.8027 4.57229C18.9983 2.76788 16.5518 1.75289 14 1.75ZM14 7.875C14.6922 7.875 15.3689 8.08027 15.9445 8.46486C16.5201 8.84944 16.9687 9.39607 17.2336 10.0356C17.4985 10.6751 17.5678 11.3789 17.4327 12.0578C17.2977 12.7367 16.9644 13.3604 16.4749 13.8499C15.9854 14.3394 15.3617 14.6727 14.6828 14.8077C14.0039 14.9428 13.3001 14.8735 12.6606 14.6086C12.0211 14.3437 11.4744 13.8951 11.0899 13.3195C10.7053 12.7439 10.5 12.0672 10.5 11.375C10.5 10.4467 10.8687 9.5565 11.5251 8.90013C12.1815 8.24375 13.0717 7.875 14 7.875Z",
    fill: "#2A2E37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinFill);
export default __webpack_public_path__ + "static/media/map-pin-fill.79f48cde300b2958cb6e60d4f7eeb18f.svg";
export { ForwardRef as ReactComponent };